<template>
  <div class="contents3">
    <!-- pc -->
    <img class="bg" src="static/img/service/site_service_img_03.png" v-show="!isMobile" />
    <div class="contents" v-show="!isMobile">
      <div class="text">
        <div class="wrap">
          <div class="icon">
            <img src="static/img/icon_repair.png" />
          </div>
          <div class="title">카수리 <span>타이어</span></div>
          <div class="body">
            <p>타이어 교체도 카수리에서 해결하세요!</p>
            <p>
              1. 제조상의 결함이 없는 1년 이내 생산된 정품 타이어<br />
              2. 전국 어디서나 동일한 가격!<br />
              3. 구매 후, 전국 무료 장착점에 방문만 하면 OK!<br />
            </p>
          </div>
          <div class="btn">
            <a @click="gotoPage('https://www.carsuri.co.kr/intro?tab=1')"><img src="static/img/service/btn.png"/></a>
          </div>
        </div>
      </div>
    </div>
    <!-- mobile -->
    <div class="contents" v-show="isMobile">
      <div class="img">
        <img src="static/img/mobile/service/site_service_img_03_m.png" />
      </div>
      <div class="text">
        <img src="static/img/mobile/service/background_white_03.png" />
        <div class="wrap">
          <div class="icon">
            <img src="static/img/mobile/service/icon_repair.png" />
          </div>
          <div class="title">카수리 <span>타이어</span></div>
          <div class="body">
            <p>타이어 교체도 카수리에서 해결하세요!</p>
            <p>
              1. 제조상의 결함이 없는 1년 이내 생산된<br />
              <span style="margin-left:3.7%;">정품 타이어</span><br />
              2. 전국 어디서나 동일한 가격!<br />
              3. 구매 후, 전국 무료 장착점에 방문만 하면 OK!<br />
            </p>
          </div>
          <div class="btn">
            <a @click="gotoPage('https://www.carsuri.co.kr/intro?tab=1')"><img src="static/img/mobile/service/btn.png"/></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMobile: false,
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize)
    this.resize()
  },
  methods: {
    resize() {
      if (window.innerWidth > 640) {
        this.isMobile = false
      } else {
        this.isMobile = true
      }
    },
    gotoPage(path) {
      window.open(path)
    },
  },
}
</script>

<style scoped>
.contents3 {
  width: 100%;
  position: relative;
}
.contents3 .bg {
  width: 100%;
  height: auto;
  display: block;
}
/* pc */
@media (max-width: 1280px) {
  .contents3 .contents .icon img {
    width: 32px;
    height: auto;
  }
  .contents3 .contents .title {
    font-style: normal;
    font-weight: 300;
    font-size: 30px;
    line-height: 58px;
    color: #000000;
  }
  .contents3 .contents .title span {
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 58px;
    color: #000000;
  }
  .contents3 .contents .body {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
    color: #444444;
  }
  .contents3 .contents .btn img {
    width: 160px;
    height: auto;
  }
}
@media (min-width: 1280px) {
  .contents3 .contents .icon img {
    width: 2.5vw;
    height: auto;
  }
  .contents3 .contents .title {
    font-style: normal;
    font-weight: 300;
    font-size: 2.3vw;
    line-height: 4.4vw;
    color: #000000;
  }
  .contents3 .contents .title span {
    font-style: normal;
    font-weight: bold;
    font-size: 2.3vw;
    line-height: 4.4vw;
    color: #000000;
  }
  .contents3 .contents .body {
    font-style: normal;
    font-weight: 300;
    font-size: 1.1vw;
    line-height: 1.9vw;
    color: #444444;
  }
  .contents3 .contents .btn img {
    width: 12vw;
    height: auto;
  }
}
@media (min-width: 641px) {
  .contents3 .contents {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
  .contents3 .text {
    width: 50%;
    height: 100%;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .contents3 .right {
    width: 50%;
    height: 100%;
    float: left;
  }
  .contents3 .right img {
    width: 100%;
    height: 100%;
  }
  .contents3 .contents .body p {
    margin: 5% 0;
  }
  .contents3 .contents .btn {
    margin-top: 15%;
  }
  .contents3 .contents .btn a {
    cursor: pointer;
  }
}
/* mobile */
@media (max-width: 640px) {
  .contents3 .img img {
    width: 100%;
    height: 100%;
  }
  .contents3 .text {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .contents3 .text img {
    width: 100%;
    height: 100%;
  }
  .contents3 .text .wrap {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 0 0 0 5%;
  }
  .contents3 .contents .icon img {
    width: 8vw;
    height: auto;
  }
  .contents3 .contents .title {
    font-style: normal;
    font-weight: 300;
    font-size: 6.5vw;
    line-height: 8.5vw;
    color: #000000;
  }
  .contents3 .contents .title span {
    font-style: normal;
    font-weight: bold;
    font-size: 6.5vw;
    line-height: 8.5vw;
    color: #000000;
  }
  .contents3 .contents .body {
    font-style: normal;
    font-weight: 300;
    font-size: 4.3vw;
    line-height: 6.5vw;
    color: #444444;
  }
  .contents3 .contents .btn img {
    width: 50vw;
    height: auto;
  }
  .contents3 .contents .icon {
    margin-top: 15%;
    margin-bottom: 5%;
  }
  .contents3 .contents .body p {
    margin: 5% 0;
  }
  .contents3 .contents .btn {
    margin-top: 15%;
  }
  .contents3 .contents .btn a {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contents/service/Contents3.vue